<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4 mt-2 text-center">
      <div class="col-12">
        <div class="platform-cards-container">
          <!-- Instagram -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'instagram' }"
            (click)="setPlatform('instagram')"
          >
            <div class="platform-icon ig">
              <i class="fab fa-instagram"></i>
            </div>
            <span class="platform-name">Instagram</span>
          </div>

          <!-- Facebook -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'facebook' }"
            (click)="setPlatform('facebook')"
          >
            <div class="platform-icon fb">
              <i class="fab fa-facebook-f"></i>
            </div>
            <span class="platform-name">Facebook</span>
          </div>

          <!-- YouTube -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'youtube' }"
            (click)="setPlatform('youtube')"
          >
            <div class="platform-icon yt">
              <i class="fab fa-youtube"></i>
            </div>
            <span class="platform-name">YouTube</span>
          </div>

          <!-- TikTok -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'tiktok' }"
            (click)="setPlatform('tiktok')"
          >
            <div class="platform-icon tt">
              <i class="fab fa-tiktok"></i>
            </div>
            <span class="platform-name">TikTok</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-reg">STRATEGY </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/semantika"
            >SEMANTIKA
          </a>
          <!-- <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/performance"
            >PERFORMANCE
          </a> -->
          <a class="btn btn-dark btn-sm btn-new">NOTES </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/mediaroom/social"
            >MEDIAROOM
          </a>
          <!-- <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/mediaroomRegistry"
            >registry
          </a> -->
        </div>
        <button class="" routerLink="/marketing/social/requestIntake">
          request intake
        </button>
      </div>
    </div>

    <div class="strategy-container p-4 bg-white rounded my-4" *ngIf="!loading">
      <form [formGroup]="strategyForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="row align-items-center mb-4">
          <div class="col">
            <h2 class="mb-1 fw-bold text-dark text-uppercase">Strategy</h2>
          </div>
          <!-- <div class="col-auto">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm w-100 bg-white p-1 text-dark d-flex align-items-center justify-content-center rounded btn-shedule"
            >
              <i class="far fa-edit me-2"></i> SCHEDULE
            </button>
          </div> -->
        </div>

        <!-- Row 1: Core details -->
        <div class="row g-3 mb-4">
          <div class="col-md-4 col-lg-4">
            <label class="form-label small text-dark fw-bold" for="id"
              ><strong>ID</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="id"
                formControlName="id"
                style="font-weight: 500; padding: 0 10px"
              />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <label class="form-label small text-dark fw-bold" for="platform"
              ><strong>Platform</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <!-- class="input-group-text bg-white border-0 h-100" -->
              <div class="input-group-prepend h-100 pl-1 align-items-center">
                <span
                  class="platform-icon"
                  style="padding: 0 12px; display: flex; align-items: center"
                  [ngClass]="selectedPlatformInfo.class"
                >
                  <i [class]="selectedPlatformInfo.icon"></i>
                  <!-- + ' text-muted' -->
                </span>
              </div>
              <select
                class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                id="platform"
                formControlName="platform"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              >
                <option
                  *ngFor="let platform of platforms"
                  [value]="platform.value"
                >
                  {{ platform.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <label class="form-label small text-dark fw-bold" for="surface"
              ><strong>Surface</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  <i class="fas fa-play text-info"></i>
                </span>
              </div>
              <select
                class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                id="surface"
                formControlName="surface"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              >
                <option
                  *ngFor="let surface of getSurfacesByPlatform()"
                  [value]="surface.value"
                >
                  {{ surface.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="col-md-3 col-lg-2 p-0">
            <label class="form-label small text-dark fw-bold" for="postingDate"
              ><strong>Posting Date</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100 text-muted"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  <i class="far fa-calendar"></i>
                </span>
              </div>
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="postingDate"
                formControlName="postingDate"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              />
            </div>
          </div> -->
          <!-- <div class="col-md-12 col-lg-2 mt-3 mt-lg-0">
            <label class="form-label small text-dark fw-bold" for="postingTime"
              ><strong>Posting Time</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100 text-muted"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  <i class="far fa-clock"></i>
                </span>
              </div>
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="postingTime"
                formControlName="postingTime"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              />
            </div>
          </div> -->
        </div>

        <!-- Row 2: Selectors -->
        <div class="row g-4 mb-4">
          <!-- Universe -->
          <div class="col-md-4">
            <label class="form-label text-dark small fw-bold" for="universe"
              ><strong>Universe</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100 fs-5 fw-bold text-primary"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  C
                </span>
              </div>
              <!-- <select
                class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                id="universe"
                formControlName="universe"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              >
                <option *ngFor="let u of universes" [value]="u">{{ u }}</option>
              </select> -->
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="universe"
                formControlName="universe"
                style="font-weight: 500; padding: 0 10px"
              />
            </div>
          </div>

          <!-- Category -->
          <div class="col-md-4">
            <label class="form-label text-dark small fw-bold" for="category"
              ><strong>Category</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100 text-primary"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  <i class="fas fa-balance-scale"></i>
                </span>
              </div>
              <!-- <select
                class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                id="category"
                formControlName="category"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              >
                <option *ngFor="let cat of getCategories" [value]="cat">
                  {{ cat }}
                </option>
              </select> -->
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="category"
                formControlName="category"
                style="font-weight: 500; padding: 0 10px"
              />
            </div>
          </div>
          <!-- Objective -->
          <div class="col-md-4">
            <label class="form-label text-dark small fw-bold" for="objective"
              ><strong>Objective</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <div class="input-group-prepend h-100">
                <span
                  class="input-group-text bg-white border-0 h-100 text-primary"
                  style="padding: 0 12px; display: flex; align-items: center"
                >
                  <i class="fas fa-bullseye"></i>
                </span>
              </div>
              <select
                class="form-control form-select border-0 px-2 h-100 shadow-none m-0"
                id="objective"
                formControlName="objective"
                style="
                  border-radius: 6px;
                  border: 1px solid #ced4da;
                  height: 32px;
                  padding: 0 10px;
                "
              >
                <option *ngFor="let obj of objectives" [value]="obj">
                  {{ obj }}
                </option>
              </select>
            </div>
          </div>

          <!-- <div class="col-md-6 py-3">
            <label class="form-label text-dark small fw-bold" for="source"
              ><strong>Source</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="source"
                formControlName="source"
                style="padding: 0 10px"
              />
            </div>
          </div> -->
        </div>

        <!-- Row 3: Notes -->
        <div class="row mb-2">
          <div class="col-12">
            <label class="form-label text-dark small fw-bold"
              ><strong>Focus Notes</strong>
              <span class="text-muted fw-normal"
                >(optional but recommended)</span
              >
            </label>
            <div
              class="position-relative"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
              "
            >
              <textarea
                class="form-control border-0 shadow-none p-2"
                rows="3"
                formControlName="focusNotes"
                style="resize: none; border-radius: 6px"
                maxlength="500"
                placeholder="Focus Notes (optional but recommended)"
              ></textarea>
              <div
                class="position-absolute bottom-0 end-0 p-2 text-muted small"
              >
                {{ strategyForm.get("focusNotes")?.value?.length || 0 }} / 500
              </div>
            </div>
          </div>
        </div>

        <!-- Row 4: Constraints -->
        <div class="row mb-5 py-3">
          <div class="col-12">
            <label class="form-label text-dark small fw-bold"
              ><strong>Semantika Instructions</strong></label
            >
            <div
              class="input-group"
              style="
                border: 1px solid #ced4da;
                border-radius: 6px;
                overflow: hidden;
                height: 42px;
              "
            >
              <input
                type="text"
                class="form-control border-0 px-2 h-100 shadow-none m-0"
                id="semantikaInstructions"
                formControlName="semantikaInstructions"
                style="padding: 0 10px"
              />
              <span
                class="input-group-text bg-white border-0 text-muted"
                style="padding: 0 12px"
              >
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Footer / Submit -->
        <div class="text-center mt-3 mb-2">
          <button
            type="submit"
            class="btn btn-dark px-5 py-2 rounded fw-bold shadow-sm btn-send"
            style="border-radius: 6px; letter-spacing: 0.5px"
          >
            SUBMIT INITIATIVE
          </button>
          <!-- <div
            class="text-primary small mt-2"
            style="color: #637cb3 !important"
          >
            All selections are governed. Review before submission.
          </div> -->
        </div>
      </form>
    </div>
  </div>
</div>
